import { ICON_COLORS as IC } from '@constants/colors.ts';
import styled from 'styled-components';

export const CloseIconWrapper = styled.div`
    span[role='img'] {
        cursor: pointer;
        color: ${IC.primary};
        width: 24px;
        height: 24px;
    }
`;
